import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatCheckbox } from '@angular/material/checkbox';
import { TranslocoPipe } from '@jsverse/transloco';

import { BaseControlComponent } from '~components/form/base-control/base-control.component';

@Component({
    selector: 'arc-checkbox',
    templateUrl: './checkbox.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [MatCheckbox, ReactiveFormsModule, TranslocoPipe]
})
export class CheckboxComponent extends BaseControlComponent {
    @Input() isRequired = false;
    @Input() isIndeterminate = false;
    @Input() showLabelInFront = false;
}
